import React from 'react';
import { MenuItem, TextField } from '@mui/material';

export const reportQueryParamOptions = ['x1', 'x2', 'x3', 'x4', 'x5', 'x6', 'x7', 'x8'];

type Props = {
  value: string[];
  onChange: (params: string[]) => any;
};

const ReportQueryParamsSelect = ({ value, onChange }: Props) => {
  return (
    <TextField
      size="small"
      select
      label="Click Parameters in Revenue Report"
      helperText="Original click values added as columns to each revenue report row. Applies to reports generated after saving."
      value={value}
      onChange={(e) => {
        const selected = e.target.value as unknown as string[] | string;
        const params = typeof selected === 'string' ? selected.split(',') : selected;
        onChange(reportQueryParamOptions.filter((p) => params.includes(p)));
      }}
      SelectProps={{
        multiple: true,
        renderValue: (selected) => (selected as string[]).join(', '),
      }}
      fullWidth
    >
      {reportQueryParamOptions.map((param) => (
        <MenuItem key={param} value={param}>
          {param}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default ReportQueryParamsSelect;
